/**
*****************************************
*										                    *
* NAGARRO  - CSX - CONFIDENTIAL         *
*										                    *
*****************************************
*/
import { Component, HostListener, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { PermitAll } from '@csx/security';
import { LmsBaseAppComponent } from '../../core/component/base-app/lms-base-app.component';
import { Header } from '../../core/model/header.model';
import { LocoDetail } from '../../core/model/loco-detail.model';
import { LocomotiveErrors } from '../../core/model/locomotive-error.model';
import { MessageDetails } from '../../core/model/message-details.model';
import { Response } from '../../core/model/response.model';
import { TabData } from '../../core/model/tab-data.model';
import { TabSearchParameter } from '../../core/model/tab-search-parameter.model';
import { Tab } from '../../core/model/tab.model';
import { TrainData } from '../../core/model/train-data.model';
import { AppUtilityService } from '../../core/services/app-utility.service';
import { DataStoreService } from '../../core/services/datastore.service';
import { EditModeService } from '../../core/services/edit-mode.service';
import { LmsLoaderService } from '../../core/services/lms-loader.service';
import { MessageHandlerService } from '../../core/services/message-handler.service';
import { PopupService } from '../../core/services/popup.service';
import { RouteChangePopupService } from '../../core/services/route-change-popup.service';
import { UserService } from '../../core/services/user.service';
import { TrainEditOps } from '../shared/model/train-edit-operation.model';
import { ConfigService } from './../../core/services/config.service';
import { LmsMenuService } from './../../core/services/lms-menu.service';
import { LmsModuleService } from './../../core/services/lms-module.service';
import { UtilService } from './../../core/services/util.service';
import { TrainDataService } from './../services/train-data.service';


@Component({
  selector: 'lms-train-data',
  templateUrl: './train-data.component.html',
  styleUrls: ['./train-data.component.scss']
})
@PermitAll()
export class LmsTrainDataComponent extends LmsBaseAppComponent implements OnInit, OnChanges, OnDestroy {

  selectedLoco: LocoDetail;

  trainEditMode: any;

  selectedId: string;

  subTypes: string[];

  trainEdit: TrainEditOps;

  locoUpdateErrors: Map<string, LocomotiveErrors>;

  responseHeader: Response;

  popHideAction: any;

  topToBottom: string;

  bottomToTop: string;

  hideSplitBtn: string;

  popUpServiceSubscription: any;

  editTrainSubscription: any;

  windowCode = 'LWTD';

  isAddOperation = false;

  maxDateValue: Date = new Date('06/30/2017');
  minDateValue: Date = new Date('06/10/2017');
  dateValue: Date = new Date('06/13/2017');
  disableCancelComplete: boolean;
  // trainEditOpsOb: Observable<TrainEditOps>;
  // private trainEditOpsBS: Subject<TrainEditOps>;

  /**
   * Creates an instance of LmsTrainComponent and inject TrainDataService,
   * ConfigService, LmsMenuService and UtilService
   * @param {TrainDataService} trainDataServie
   * @param {LmsModuleService} lmsModuleService
   * @param {ConfigService} configService
   * @param {LmsMenuService} lmsMenuService
   * @param {UtilService} utilService
   * @memberOf LmsTrainComponent
   */
  constructor(private trainDataServie: TrainDataService,
    lmsModuleService: LmsModuleService,
    configService: ConfigService,
    lmsMenuService: LmsMenuService,
    utilService: UtilService,
    editModeService: EditModeService,
    routerChangePopUpService: RouteChangePopupService,
    private dataStoreService: DataStoreService,
    private lmsLoaderService: LmsLoaderService,
    private messageHandlerService: MessageHandlerService,
    popupService: PopupService,
    private appUtilityService: AppUtilityService, 
    public user: UserService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routerChangePopUpService, popupService);
    this.service = this.trainDataServie;
    this.type = this.configService.getConfigData().menu.type.train;
    this.popUpServiceSubscription = this.popupService.successObservable.subscribe((data) => {
      if (data && data.action && data.action === true) {
        this.checkSuccessOperation(data.message);
      }
    });

    this.editTrainSubscription = this.editModeService.editResetMode.subscribe(data => {
      setTimeout(() => {
        if (data) {
          this.resetTrainOperation();
        }
      }, 500);
      // this.editModeService.setEditResetMode(false);
    });

    this.trainEdit = {
      selectedLocomotives: [],
      draggable: true,
      submitAction: false,
      locoSelection: true,
      locoEditMode: false,
      dragMode: false,
      editDisable: (this.loadData && this.loadData.locoDetails && this.loadData.locoDetails.length > 0) ? false : true,
      cancelDisable: true,
      submitDisable: true,
      otherActionDisable: false
    };

    if (this.user && this.user.isUserManagerOrDirector) {
      this.trainEdit.draggable = true;
    } else {
      this.trainEdit.draggable = false;
    }

  }

  private checkSuccessOperation(message: string) {
    this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
    this.resetTrainOperation();
    this.checkEditModeStatus();
    setTimeout(() => {
      this.trainDataServie.load(this.selectedTab, true, message);
    }, 5);
  }

  /**
   * This method invoked when component is loaded and fetch the data from service
   * for selected tab.
   * @memberOf LmsTrainComponent
   */
  ngOnInit() {
    this.resetTrainOperation();
    super.init(this.search);
  }

  /**
   * @memberOf LmsTrainDataComponent
   */
  ngOnChanges() {

  }

  /**
   * This method is used to update
   * the currently selected tab
   * @param {any} event
   * @memberOf LmsTrainDataComponent
   */
  public updateTabAction(event) {
    if (event) {
      this.selectedTab = event;
      this.lmsModuleService.updateSelectedTab(this.selectedTab);
    }
  }

  /**
   * This method is used to handle the
   * edit action operation
   * @param {any} event
   * @memberOf LmsTrainDataComponent
   */
  public editActionTrigger(event) {
    // this.selectedTab.mode = 'trainEditMode';
    if (event) {
      this.trainEdit = null;
      this.trainEdit = event;
      this.topToBottom = 'editAllOps';
    }
  }

  resetLoco() {
    if (this.loadData.isLocated && this.loadData.locoDetails && this.loadData.locoDetails.length > 0) {
      const tabData = this.dataStoreService.getValue(this.selectedTab);
      const trainData = <TrainData>(tabData.data[this.selectedTab.subType]);
      for (let i = 0; i < this.loadData.locoDetails.length; i++) {
        if (this.loadData.locoDetails[i].isLocated) {
          this.loadData.locoDetails[i].isLocated = false;
          trainData.locoDetails[i].isLocated = false;
          break;
        }
      }
      this.loadData.isLocated = false;
      trainData.isLocated = false;
      const tabDataNew = <TabData>({
        id: this.selectedTab.id,
        subType: this.selectedTab.subType
      });
      tabDataNew.data = {};
      tabDataNew.data[this.selectedTab.subType] = trainData;
      this.dataStoreService.putValue(this.selectedTab, tabDataNew);
    }
  }

  /**
   * This method is used to communicate
   * between components when certain action triggered
   * @param {any} event
   * @memberOf LmsTrainDataComponent
   */
  public actionTriggered(event) {
    if (event) {
      if ('editAll' === event) {
        this.resetLoco();
        // this.lmsLoaderService.showLoader();
      } else if ('cancel' === event) {
        this.search();
        this.popHideAction = {};
      } else if ('dragSubmit' === event) {
        this.resequenceLocmotiveSubmit();
      } else if ('resetOps' === event) {
        this.resetTrainOperation();
      }
      this.topToBottom = event;
    }
  }

  /**
   * This method is used to redirect action
   * from bottomToTop like from parent to child
   * @param {any} event
   * @memberOf LmsTrainDataComponent
   */
  public bottomUpActionTrigger(event) {
    if (event) {
      if ('hideContextMenu' === event) {
        this.hideContextMenuChild();
      }
      this.bottomToTop = event;
      this.resetLoco();
    }
  }

  /**
   * This method is used to make
   * service call for add train operation
   * @param {any} event
   * @memberOf LmsTrainDataComponent
   */
  public addTrainOperation(event) {
    const trainId = event;
    let header: Header;
    this.responseHeader = null;
    this.trainDataServie.addTrain(trainId).subscribe(
      (data) => {
        header = <Header>data;
        if (this.isNumeric(header.priorityCode)) {
          const pCode = parseInt(header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            setTimeout(() => {
              const tabSearchParameter = <TabSearchParameter>({ searchText: event });
              this.popupService.setPageMode('');
              this.popupService.setSubmitBtnId('');
              this.lmsLoaderService.hideLoader();
              this.resetTrainOperation();
              this.checkEditModeStatus();
              this.lmsModuleService.removeTab(this.selectedTab);
              if (this.selectedTab) {
                this.isAddOperation = true;
                this.appUtilityService.navigateByUrl(this.selectedTab.type, this.selectedTab.subType, event, true);
              }
            }, 100);
            this.popHideAction = { action: 'AddTrain', message: '' };
            this.messageHandlerService.handleMessage(<MessageDetails>({
              type: this.configData.message.type.client,
              level: this.configData.message.level.success,
              target: this.configData.message.target.page,
              message: 'Train re-add has been initiated.  Please inquire in a minute.'
            }));
          } else {
            this.popHideAction = { action: 'ErrorTrain', message: header.messageText };
            this.lmsLoaderService.hideLoader();
          }
        }
      }, error => {
        this.popHideAction = { action: 'ErrorTrain', message: this.appUtilityService.getHttpErroMessage(error, false) };
        this.lmsLoaderService.hideLoader();
      }
    );
  }

  /**
   * This method is a service call
   * for cancel and complete train
   * operation
   * @param {any} event
   * @memberOf LmsTrainDataComponent
   */
  public cancelCompleteTrainOperation(event) {
    let opr: any;
    const cancelTrain = {
      station: this.loadData.currentTerminal,
      trainRow: [
        {
          trainID: this.loadData.trainIdentifier,
          trainType: this.loadData.trainType
        }
      ]
    };
    if (event && event === 'completeTrain') {
      opr = 'CMPL';
    } else if (event && event === 'cancelTrain') {
      opr = 'CNCL';
    }
    this.responseHeader = null;
    this.trainDataServie.cancelCompleteTrain(cancelTrain, opr).subscribe(
      (data) => {
        this.responseHeader = <Response>data;
        if (this.isNumeric(this.responseHeader.header.priorityCode)) {
          const pCode = parseInt(this.responseHeader.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.disableCancelComplete = false;
            setTimeout(() => {
              const tabSearchParameter = <TabSearchParameter>({ searchText: '' });
              const newTab = <Tab>({
                type: this.selectedTab.type, subType: this.selectedTab.subType,
                selected: true, tabSearchParameter: tabSearchParameter
                , status: this.configService.getConfigData().tabStatus.blank
              });
              this.resetTrainOperation();
              this.checkEditModeStatus();
              this.lmsModuleService.removeTab(this.selectedTab);
              this.popHideAction = { action: 'CnfrmActn', message: '' };
              this.messageHandlerService.handleMessage(<MessageDetails>({
                type: this.configData.message.type.client,
                level: this.configData.message.level.success,
                target: this.configData.message.target.page,
                message: this.responseHeader.header.messageText
              }));
              this.popupService.setPageMode('');
              this.popupService.setSubmitBtnId('');
              this.lmsLoaderService.hideLoader();
              if (newTab) {
                this.appUtilityService.navigateByUrl(newTab.type, newTab.subType, '', true);
              }
            }, 200);
          } else {
            this.disableCancelComplete = true;
            const submitBtn = document.getElementById('cancelCompleteNoButton');
            if (submitBtn) {
              this.popupService.setPageMode('Dialog');
              this.popupService.setSubmitBtnId('cancelCompleteNoButton');
              submitBtn.focus();
            }
            this.popHideAction = { action: 'ErrorCnfrmActn', message: this.responseHeader.header.messageText };
            this.lmsLoaderService.hideLoader();
          }
        }
      }, error => {
        this.disableCancelComplete = false;
        this.popHideAction = { action: 'ErrorCnfrmActn', message: this.appUtilityService.getHttpErroMessage(error, false) };
        this.lmsLoaderService.hideLoader();
      }
    );
  }

  /**
   * This is emiiter to set false variable again
   * @param {any} event
   * @memberof LmsTrainDataComponent
   */
  disableCancelCompleteEmit(event) {
    this.disableCancelComplete = event;
  }

  /**
   * This method is a service call for
   * set train position operation
   * @param {any} event
   * @returns
   * @memberOf LmsTrainDataComponent
   */
  public setTrainPositionAction(event) {
    if (!event) {
      return;
    }
    this.responseHeader = null;
    this.trainDataServie.setTrainPosition(this.loadData.trainIdentifier).subscribe(
      (data) => {
        this.responseHeader = data;
        if (this.isNumeric(this.responseHeader.header.priorityCode)) {
          const pCode = parseInt(this.responseHeader.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
            this.trainDataServie.load(this.selectedTab);
            this.messageHandlerService.handleMessage(<MessageDetails>({
              type: this.configData.message.type.client,
              level: this.configData.message.level.success,
              target: this.configData.message.target.page,
              message: this.responseHeader.header.messageText
            }));
          } else {
            this.selectedTab.subTypeDetail.data.message = this.responseHeader.header.messageText;

            const editModeStatus = {
              status: false,
              message: ''
            };
            this.editModeService.setEditMode(editModeStatus);
            setTimeout(() => {
              this.lmsModuleService.updateSelectedTab(this.selectedTab);
              this.lmsLoaderService.hideLoader();
            }, 5);
            setTimeout(() => {
              this.checkEditModeStatus();
            }, 10);
          }
          this.lmsLoaderService.hideLoader();
        }
      }, error => {
        this.selectedTab.subTypeDetail.data.message = this.appUtilityService.getHttpErroMessage(error, false);
        const editModeStatus = {
          status: false,
          message: ''
        };
        this.editModeService.setEditMode(editModeStatus);
        setTimeout(() => {
          this.lmsModuleService.updateSelectedTab(this.selectedTab);
          this.lmsLoaderService.hideLoader();
        }, 5);
        setTimeout(() => {
          this.checkEditModeStatus();
        }, 10);
      }
    );
  }

  /**
   * This method is a service call for
   * cancel locomotive plan operation
   * @param {any} event
   * @returns
   * @memberOf LmsTrainDataComponent
   */
  public cancelLocomotivePlan(event) {
    const selectedLoco = event;
    if (selectedLoco && selectedLoco.length > 0) {
      const locos = this.getSelectedLocomotives(selectedLoco);
      const request = {
        thpTerminal: '',
        terminalHandlingType: '',
        trainId: this.loadData.trainIdentifier,
        otherLocosList: locos
      };
      const operation = {
        operation: 'CancelLocomotivePlan',
        data: request,
        selectedTab: this.selectedTab,
        currentTerminal: this.loadData.currentTerminal,
        windowCode: 'LWTD'
      };
      this.popupService.setPopupOperation(operation);
    } else {
      return;
    }
  }

  /**
   * This method is used to prepare the request
   * object of selected locomotives
   * @private
   * @param {LocoDetail[]} locos
   * @returns
   * @memberOf LmsTrainDataComponent
   */
  private getSelectedLocomotives(locos: LocoDetail[]) {
    const selection = [];
    for (let i = 0; i < locos.length; i++) {
      const loco = locos[i];
      const select = {
        rowID: '',
        locomotiveID: this.appUtilityService.formatLocomotiveId(loco.locomotiveIdentifier),
        assignedPlannedFlag: loco.assignedPlannedFlag,
        qualifier: loco.qualifier
      };
      selection.push(select);
    }
    return selection;
  }

  /**
   * this method is used to resequence the locomotives
   * when user drops a dragged locomotive.
   * This method is used to display new positions of locomotives
   * to user once dropped a dragged locomotive.
   * @param {any} event
   * @memberOf LmsTrainDataComponent
   */
  public reSequenceTrainData(event) {
    if (this.trainEdit.dragMode) {
      this.loadData = event;
      this.popupService.setPageMode('Edit');
      this.popupService.setSubmitBtnId('trainDataSubmitBtn');
    }
  }

  /**
   * This method is a service call
   * for update locomotive operation
   * @param {any} event
   * @memberOf LmsTrainDataComponent
   */
  public submitEditedTrainData(event) {
    this.locoUpdateErrors = new Map<string, LocomotiveErrors>();
    const locomotives: LocoDetail[] = event;
    let responseHeader: any;
    let errors: LocomotiveErrors[];
    if (locomotives && locomotives.length > 0) {
      const editRequest = this.prepareEditRequest(locomotives);
      this.lmsLoaderService.showLoader();
      this.trainDataServie.trainLocomotiveUpdate(editRequest).subscribe(
        (data) => {
          responseHeader = data;
          if (this.isNumeric(responseHeader.header.priorityCode)) {
            const pCode = parseInt(responseHeader.header.priorityCode, 10);
            if (pCode >= 1 && pCode <= 4) {
              this.locoUpdateErrors = new Map<string, LocomotiveErrors>();
              this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
              this.resetTrainOperation();
              this.checkEditModeStatus();
              this.trainDataServie.load(this.selectedTab);
              this.messageHandlerService.handleMessage(<MessageDetails>({
                type: this.configData.message.type.client,
                level: this.configData.message.level.success,
                target: this.configData.message.target.page,
                message: responseHeader.header.messageText
              }));
              this.lmsLoaderService.hideLoader();
              this.popupService.setPageMode('');
              this.popupService.setSubmitBtnId('');
            } else {
              errors = responseHeader.listOfLocomotiveErrors;
              if (errors && errors.length > 0) {
                this.locoUpdateErrors = this.prepareErrorMapForLocmotiveUpdates(errors, this.trainEdit.selectedLocomotives);
              }
              this.selectedTab.subTypeDetail.data.message = responseHeader.header.messageText;
              const editModeStatus = {
                status: false,
                message: ''
              };
              this.editModeService.setEditMode(editModeStatus);
              setTimeout(() => {
                this.lmsModuleService.updateSelectedTab(this.selectedTab);
              }, 10);
              setTimeout(() => {
                this.checkEditModeStatus();
              }, 15);
              setTimeout(() => {
                window.scroll(0, 0);
                this.lmsLoaderService.hideLoader();
              }, 50);
            }
          }
        }, error => {
          this.selectedTab.subTypeDetail.data.message = this.appUtilityService.getHttpErroMessage(error, false);

          const editModeStatus = {
            status: false,
            message: ''
          };
          this.editModeService.setEditMode(editModeStatus);
          setTimeout(() => {
            this.lmsModuleService.updateSelectedTab(this.selectedTab);
          }, 5);
          setTimeout(() => {
            this.checkEditModeStatus();
          }, 10);
          setTimeout(() => {
            window.scroll(0, 0);
            this.lmsLoaderService.hideLoader();
          }, 50);
        }
      );
    }
  }

  /**
   * This method is used to check for edit mode status
   * of the screen user currently on
   * @memberOf LmsTrainDataComponent
   */
  public checkEditModeStatus() {
    if (this.loadData && this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status !== 'blank'
      && this.trainEdit && (this.trainEdit.dragMode || this.trainEdit.locoEditMode)) {
      const editModeStatus = {
        status: true,
        message: 'Unsaved data will be lost. Do you want to continue?'
      };
      this.editModeService.setEditMode(editModeStatus);
    } else {
      const editModeStatus = {
        status: false,
        message: ''
      };
      this.editModeService.setEditMode(editModeStatus);
    }
  }

  /**
   * this method is helper method when we
   * call for update locomotive and used to prepare
   * the error map
   * @private
   * @param {*} errors
   * @param {LocoDetail[]} locomotives
   * @returns
   * @memberOf LmsTrainDataComponent
   */
  private prepareErrorMapForLocmotiveUpdates(errors: any, locomotives: LocoDetail[]) {
    const errorMap: Map<string, LocomotiveErrors> = new Map<string, LocomotiveErrors>();
    let errorItr = 0;
    for (let i = 0; (i < locomotives.length) && (errorItr < errors.length); i++) {
      const error = errors[errorItr];
      if ((i + 1) === parseInt(error.rowId, 10)) {
        errorMap.set(locomotives[i].locomotiveIdentifier, error);
        errorItr++;
      } else {
        const errorDup = {
          milesError: '',
          directionFacingError: '',
          fuelStationError: '',
          fuelMMDDError: '',
          deadIsolatedError: ''
        };
        errorMap.set(locomotives[i].locomotiveIdentifier, errorDup);
      }
    }
    return errorMap;
  }

  /**
   * This method is used to prepare the
   * request object when we make a service call
   * for locomotive update
   * @private
   * @param {LocoDetail[]} locomotives
   * @returns {*}
   * @memberOf LmsTrainDataComponent
   */
  private prepareEditRequest(locomotives: LocoDetail[]): any {
    const editRequest = {
      thpTerminal: this.loadData.currentTerminal,
      trainId: this.loadData.trainIdentifier,
      otherLocosList: this.prepareEditedLocomotiveList(locomotives)
    };
    return editRequest;
  }

  /**
   * This method is a helper method for the prepareEditRequest()
   * method. this is used to prepare the list of locomotives
   * @private
   * @param {LocoDetail[]} locomotives
   * @returns {*}
   * @memberOf LmsTrainDataComponent
   */
  private prepareEditedLocomotiveList(locomotives: LocoDetail[]): any {
    const otherLocosList = [];

    for (let i = 0; i < locomotives.length; i++) {
      const loco = {
        rowID: i + 1 + '',
        locomotiveID: this.appUtilityService.formatLocomotiveId(locomotives[i].locomotiveIdentifier),
        assignedPlannedFlag: locomotives[i].assignedPlannedFlag,
        direction: locomotives[i].directionFacing,
        fuelLocation: locomotives[i].lastFueledLocation,
        fuelDate: locomotives[i].lastFueledDate,
        milesRemaining: locomotives[i].miles,
        remarks: locomotives[i].remarks,
        deadIsolatedFlag: locomotives[i].deadIsolatedFlag
      };
      otherLocosList.push(loco);
    }
    return otherLocosList;
  }

  /**
   * this is a service call for resequence locomotives
   * @private
   * @memberOf LmsTrainDataComponent
   */
  private resequenceLocmotiveSubmit() {
    const request = {
      thpTerminal: this.loadData.currentTerminal,
      terminalHandlingType: '',
      trainId: this.loadData.trainIdentifier,
      otherLocosList: this.getLocomotiveList()
    };
    this.responseHeader = null;
    this.trainDataServie.resequenceLocomotives(request, this.loadData.currentTerminal).subscribe(
      (data) => {
        this.responseHeader = data;
        if (this.isNumeric(this.responseHeader.header.priorityCode)) {
          const pCode = parseInt(this.responseHeader.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.popHideAction = 'rSeqComplete';
            this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
            this.resetTrainOperation();
            this.checkEditModeStatus();
            setTimeout(() => {
              this.trainDataServie.load(this.selectedTab);
              this.messageHandlerService.handleMessage(<MessageDetails>({
                type: this.configData.message.type.client,
                level: this.configData.message.level.success,
                target: this.configData.message.target.page,
                message: this.responseHeader.header.messageText
              }));
              this.lmsLoaderService.hideLoader();
            }, 5);
            this.popupService.setPageMode('');
            this.popupService.setSubmitBtnId('');
          } else {
            this.selectedTab.subTypeDetail.data.message = this.responseHeader.header.messageText;
            const editModeStatus = {
              status: false,
              message: ''
            };
            this.editModeService.setEditMode(editModeStatus);
            setTimeout(() => {
              this.lmsModuleService.updateSelectedTab(this.selectedTab);
              this.lmsLoaderService.hideLoader();
            }, 5);
            setTimeout(() => {
              this.checkEditModeStatus();
            }, 10);
          }
        }
      }, error => {
        this.selectedTab.subTypeDetail.data.message = this.appUtilityService.getHttpErroMessage(error, false);


        const editModeStatus = {
          status: false,
          message: ''
        };
        this.editModeService.setEditMode(editModeStatus);
        setTimeout(() => {
          this.lmsModuleService.updateSelectedTab(this.selectedTab);
          this.lmsLoaderService.hideLoader();
        }, 5);
        setTimeout(() => {
          this.checkEditModeStatus();
        }, 10);
      }
    );
  }

  /**
   * This method is a helper method for service
   * call to resequence locomotives.
   * this is used to prepare the locomotive list
   * @private
   * @returns
   * @memberOf LmsTrainDataComponent
   */
  private getLocomotiveList() {
    const otherLocos = [];
    if (this.loadData && this.loadData.locoDetails) {
      for (let i = 0; i < this.loadData.locoDetails.length; i++) {
        const loco: LocoDetail = this.loadData.locoDetails[i];
        const locomotive = {
          rowID: '',
          locomotiveID: this.appUtilityService.formatLocomotiveId(loco.locomotiveIdentifier),
          assignedPlannedFlag: loco.assignedPlannedFlag
        };
        otherLocos.push(locomotive);
      }
    }
    return otherLocos;
  }

  /**
   * This method is used to reset train operations
   * @private
   * @memberOf LmsTrainDataComponent
   */
  private resetTrainOperation() {
    this.trainEdit = {
      selectedLocomotives: [],
      draggable: true,
      submitAction: false,
      locoSelection: true,
      locoEditMode: false,
      dragMode: false,
      editDisable: (this.loadData && this.loadData.locoDetails && this.loadData.locoDetails.length > 0) ? false : true,
      cancelDisable: true,
      submitDisable: true,
      otherActionDisable: false
    };
    this.topToBottom = '';
    this.bottomToTop = '';
    if (this.user && this.user.isUserManagerOrDirector) {
      this.trainEdit.draggable = true;
    } else {
      this.trainEdit.draggable = false;
    }
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
  }

  /**
     * This method invoked when search for train information is performed.
     * @memberOf LmsTrainComponent
     */
  public search() {
    if (!this.isAddOperation) {
      this.trainDataServie.load(this.selectedTab);
    } else {
      this.selectedTab.subTypeDetail.data.status = 'blank';
      this.isAddOperation = false;
      this.lmsModuleService.updateSelectedTab(this.selectedTab);
    }
    if (this.isEditMode) {
      this.resetTrainOperation();
    }
  }

  /**
   * this method is used to show the context panel for locomotive
   * when user right click on any locomotive icon
   * @param {any} event
   * @memberOf LmsTrainComponent
   */
  public showLocomotiveContextMenu(event) {
    this.hideContextMenuChild();
    setTimeout(() => {
      this.selectedLoco = event;
      this.selectedId = 'loco' + this.selectedLoco.locomotiveIdentifier;
      this.selectedLoco.renderContextMenu = true;
    }, 5);
  }

  /**
   * this method is used to hide the context panel of locomotive
   * which comes in open state when user right click on locomotive
   * svg icon
   * @memberOf LmsTrainComponent
   */
  @HostListener('document:click') hideContextMenuChild(event?: any) {
    super.hideContextMenu('train page');
    if (!event) {
      this.hideSplitBtn = 'hide';
    } else {
      this.hideSplitBtn = 'show';
    }
  }

  /**
   * Clean the state of lifecycle hook.
   * @memberOf LmsTrainComponent
   */
  ngOnDestroy() {
    super.destroy();
    this.resetTrainOperation();
    this.popUpServiceSubscription.unsubscribe();
    this.editTrainSubscription.unsubscribe();
  }

  /**
   * Remove error when error message is closed
   * @param {any} event
   * @memberOf LmsTrainComponent
   */
  clearErrorMessage(event) {
    this.selectedTab.subTypeDetail.data.message = '';


    const editModeStatus = {
      status: false,
      message: ''
    };
    this.editModeService.setEditMode(editModeStatus);
    setTimeout(() => {
      this.lmsModuleService.updateSelectedTab(this.selectedTab);
      this.lmsLoaderService.hideLoader();
    }, 5);
    setTimeout(() => {
      this.checkEditModeStatus();
    }, 10);
  }

  /**
   * this method is used to reset all operations
   * of train data screen.
   * @memberOf LmsTrainDataComponent
   */
  resetAll() {
    this.resetTrainOperation();
  }
}
